import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { smiUrl } from 'components';
import { map, Observable } from 'rxjs';

import {
	UniversalSearchKindResult,
	UniversalSearchResponseApi
} from './universal-search.model';

export interface IUniversalSearchApiService {
	search(query: string): Observable<UniversalSearchKindResult[]>;
}

@Injectable({ providedIn: 'root' })
export class UniversalSearchApiService implements IUniversalSearchApiService {
	constructor(private http: HttpClient) {}

	search(query: string): Observable<UniversalSearchKindResult[]> {
		const url = smiUrl().add('universal-search').done();
		const params = new HttpParams({ fromObject: { q: query } });
		return this.http.get<UniversalSearchResponseApi>(url, { params }).pipe(
			map(response =>
				response.kinds.map(kind => ({
					kind: kind.kind,
					items: kind.items,
					hasMore: kind.has_more,
					notSearched: kind.not_searched
				}))
			)
		);
	}
}
